// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__241Xq","right":"styles_right__FFFBv"};